import { render, staticRenderFns } from "./includedSection.vue?vue&type=template&id=55b4da8c"
import script from "./includedSection.vue?vue&type=script&lang=js"
export * from "./includedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports